import { createContext, useContext, useEffect, useState } from "react";

const UnitContext = createContext({ unit: "cm", setUnit: () => {} });

/** Dimension unit preference (cm | in). Defaults to cm, persisted per device. */
export function UnitProvider({ children }) {
  const [unit, setUnit] = useState(() => {
    try {
      const v = localStorage.getItem("fm_dim_unit");
      return v === "in" ? "in" : "cm";
    } catch (e) {
      return "cm";
    }
  });
  useEffect(() => {
    try { localStorage.setItem("fm_dim_unit", unit); } catch (e) { /* ignore */ }
  }, [unit]);
  return <UnitContext.Provider value={{ unit, setUnit }}>{children}</UnitContext.Provider>;
}

export function useUnit() {
  return useContext(UnitContext);
}
